import { initSentry, Sentry } from "./sentry";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

initSentry();

function SentryFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md text-center">
        <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
        <p className="text-muted-foreground mb-4">
          An unexpected error occurred. Please refresh the page and try again.
        </p>
        <button
          type="button"
          className="rounded-md bg-primary px-4 py-2 text-primary-foreground"
          onClick={() => window.location.reload()}
        >
          Refresh page
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<SentryFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
